import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const napster: MusicService = {
  id: 'napster',
  name: 'Napster',
  shortName: 'Napster',
  isSupported: false,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: true,
  color: {
    primary: '#2ca6de',
    label: '#2190C4',
    background: '#1d1e22',
  },
  importerID: ImporterID.Napster,
  musicAPIID: MusicAPIIntegrationID.Napster,
  linkType: 'napster',
  assets: {
    logo: { light: 'napster-light.svg', dark: 'napster-dark.svg' },
    logoPadding: { light: 'napster-light-padding.svg', dark: 'napster-dark-padding.svg' },
    logoColor: { light: 'napster-color-light.svg', dark: 'napster-color-dark.svg' },
    logoColorPadding: {
      light: 'napster-color-light-padding.svg',
      dark: 'napster-color-dark-padding.svg',
    },
    logoOnBackground: 'napster-dark.svg',
  },
  whatIsDescription: musicServiceMessages.napsterWhatIs,
  authenticatedApiCapabilities: {
    doesSupportUpdatingPlaylists: true,
    doesSupportRemovingPlaylists: true,
    doesSupportRemovingTracks: true,
    doesSupportMovingTracks: true,
    doesSupportAddingTracksToLibrary: true,
    doesSupportRemovingTracksFromLibrary: true,
    doesSupportFetchingLibraryAlbums: true,
    doesSupportFetchingAlbums: true,
    doesSupportFetchingAlbumTracks: true,
    doesSupportAddingAlbums: true,
    doesSupportRemovingAlbums: false,
    doesSupportFetchingLibraryArtists: true,
    doesSupportFetchingArtists: true,
    doesSupportAddingArtistsToLibrary: false,
    doesSupportRemovingArtistsFromLibrary: false,
    doesSupportSearchByISRC: true,
    doesReturnISRC: true,
    doesReturnPreviewURL: true,
    doesReturnUserEmail: true,
    doesReturnUserCountry: true,
    maxLimit: 50,
  },
};
